exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-sidebar-block{margin-bottom:10px;padding:10px;border-radius:10px;width:100%;cursor:pointer}.max-lines-2{overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical}", ""]);

// exports
